import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessCapacityEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-capacity-embed',
	exact: true,
	path: '/jira/core/projects/:projectKey/capacity/embed',
};
